import React from 'react';
import { Button } from "@/components/ui/Button";
import { ArrowRight, Handshake, Users, TrendingUp } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 text-white md:h-full">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20 md:bg-fixed" 
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=2070&auto=format&fit=crop')",
          filter: 'brightness(0.7) contrast(1.2)'
        }}
      />
      
      <div className="absolute inset-0 bg-[url('/images/network-pattern.svg')] opacity-10" />
      
      <div className="container md:h-screen mx-auto px-4 py-24 relative z-10 md:mt-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Devenez Partenaire <span className="text-transparent bg-clip-text bg-gradient-to-r from-orcsys-400 to-orcsys-500">Orcsys</span>
          </h1>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Transformez votre réseau en opportunités de croissance. 
            Rejoignez notre écosystème de partenaires et développez votre activité avec Orcsys.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-orcsys-500 hover:bg-orcsys-600 text-white" onClick={() => window.location.href = '#services'}>
              Découvrir nos Services
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-orcsys-500/10 p-3 rounded-lg w-fit mb-4">
              <Handshake className="h-6 w-6 text-orcsys-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Rémunération Flexible</h3>
            <p className="text-3xl font-bold text-orcsys-400 mb-2">2 Modèles</p>
            <p className="text-slate-300">
              Lead qualifié ou commission sur contrat, choisissez le modèle qui vous convient
            </p>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-orcsys-500/10 p-3 rounded-lg w-fit mb-4">
              <Users className="h-6 w-6 text-orcsys-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Partenaires Satisfaits</h3>
            <p className="text-3xl font-bold text-orcsys-400 mb-2">100%</p>
            <p className="text-slate-300">
              De nos partenaires recommandent notre programme de rémunération
            </p>
          </div>
          <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50">
            <div className="bg-orcsys-500/10 p-3 rounded-lg w-fit mb-4">
              <TrendingUp className="h-6 w-6 text-orcsys-400" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">Projets Livrés</h3>
            <p className="text-3xl font-bold text-orcsys-400 mb-2">30+</p>
            <p className="text-slate-300">
              Applications et plateformes développées avec succès pour nos clients
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 